export const dataProps = (data) => data
    ? Object.keys(data).reduce((acc, key) => {
        const value = data[key];
        return value
            ? {
                ...acc,
                [`data-${key}`]: value,
            }
            : acc;
    }, {})
    : undefined;
